<template>
	<div class="route-info-content">
		<el-dialog
			title="路线客商配送周期调整"
			v-if="dialogVisible"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:modal-append-to-body="false"
			width="1070px"
			top="3vh"
			ref="dialog"
		>
            <div class="info">
                路线：{{ routeName }}
            </div>
			<p class="title">客商配送周期</p>
			<div class="flex">
				<div class="flex-1">
					<el-table
						border
						:data="routeAgentSums"
						:header-cell-style="{
							background: 'rgba(200, 204, 215,.6)',
							color: '#333333'
						}"
					>
						<el-table-column align="center" label="周期统计" width="90" type="index">
							<template slot-scope="scope">
								{{ list1[scope.$index] }}
							</template>
						</el-table-column>
						<el-table-column v-for="(item,i) in list2" :key="i" width="60" :label="item.name" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								{{ scope.row[item.parameter] }}
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="flex-1">
					<div class="w510">
						<el-table
							border
							:data="channelList"
							:header-cell-style="{
								background: 'rgba(200, 204, 215,.6)',
								color: '#333333'
							}"
						>
							<el-table-column align="center" label="渠道统计" type="index" width="88">
								<template slot-scope="scope">
									{{ list1[scope.$index] }}
								</template>
							</el-table-column>
							<el-table-column v-for="(item,i) in channelsList" :key="i" :width="item.channelName.length == 2 ? '60' : item.channelName.length*22+''" :label="item.channelName" :show-overflow-tooltip="true">
								<template slot-scope="scope">
									{{ scope.row[item.channelCode] }}
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
			<el-table
				border
				:data="deliveryCycleList"
				v-if="deliveryCycleList.length > 0"
				:header-cell-style="{
					background: 'rgba(200, 204, 215,.6)',
					color: '#333333'
				}"
				height="60vh"
				style="width: 100%"
			>
				<el-table-column prop="deliverSort" label="序号" width="60" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="agentName" label="客商简称" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="channelName" label="渠道" width="90" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="allSku" label="累计" width="80" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="allDaver" label="日均" width="80" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="monSort" label="周一" width="60">
					<template slot-scope="scope">
						<el-checkbox v-model="scope.row.monSort" @change="changeWeek(scope.row, '1', scope.row.monSort)"></el-checkbox>
					</template>
				</el-table-column>
				<el-table-column prop="tuesSort" label="周二" width="60">
					<template slot-scope="scope">
						<el-checkbox v-model="scope.row.tuesSort" @change="changeWeek(scope.row, '2', scope.row.tuesSort)"></el-checkbox>
					</template>
				</el-table-column>
				<el-table-column prop="wedSort" label="周三" width="60">
					<template slot-scope="scope">
						<el-checkbox v-model="scope.row.wedSort" @change="changeWeek(scope.row, '3', scope.row.wedSort)"></el-checkbox>
					</template>
				</el-table-column>
				<el-table-column prop="thurSort" label="周四" width="60">
					<template slot-scope="scope">
						<el-checkbox v-model="scope.row.thurSort" @change="changeWeek(scope.row, '4', scope.row.thurSort)"></el-checkbox>
					</template>
				</el-table-column>
				<el-table-column prop="friSort" label="周五" width="60">
					<template slot-scope="scope">
						<el-checkbox v-model="scope.row.friSort" @change="changeWeek(scope.row, '5', scope.row.friSort)"></el-checkbox>
					</template>
				</el-table-column>
				<el-table-column prop="satSort" label="周六" width="60">
					<template slot-scope="scope">
						<el-checkbox v-model="scope.row.satSort" @change="changeWeek(scope.row, '6', scope.row.satSort)"></el-checkbox>
					</template>
				</el-table-column>
				<el-table-column prop="sunSort" label="周日" width="60">
					<template slot-scope="scope">
						<el-checkbox v-model="scope.row.sunSort" @change="changeWeek(scope.row, '0', scope.row.sunSort)"></el-checkbox>
					</template>
				</el-table-column>
			</el-table>
			<div v-else class="tc mt15">暂无数据</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			dialogVisible: false,
            routeId: '',
			routeName: '',
			// 渠道列表
			channelsList: [],
			// 渠道统计列表
			channelList: [],
			// 周期统计第一列列表
			list1: ['客商合计','日均合计'],
			// 周期统计第一行列表
			list2: [
				{
					name: '周一',
					parameter: 'monSum'
				},
				{
					name: '周二',
					parameter: 'tuesSum'
				},
				{
					name: '周三',
					parameter: 'wedSum'
				},
				{
					name: '周四',
					parameter: 'thurSum'
				},
				{
					name: '周五',
					parameter: 'friSum'
				},
				{
					name: '周六',
					parameter: 'satSum'
				},
				{
					name: '周日',
					parameter: 'sunSum'
				}
			],
			// 周期统计列表
			routeAgentSums: [],
			// 配送周期列表
			deliveryCycleList: []
		};
	},
	methods: {
		init(channelsList, routeId) {
			this.routeId = routeId;
			this.$nextTick(() => {
				for (const item of channelsList) {
					item.channelCode = item.channelCode.toLowerCase();
				}
				this.channelsList = channelsList;
				this.channelList = [];
				this.getList();
			});
		},
		getList() {
			this.$request
				.post("routeMapListChannelSum", true, {
					routeId: this.routeId
				})
				.then(res => {
					if(res.code == '0') {
						this.routeName = res.data.routeName;
						this.routeAgentSums = res.data.routeAgentSums;
						this.channelList = res.data.vroutebuffLmavers;
						for (const item of res.data.agents) {
							item.monSort = item.monSort > 0 ? true : false;
							item.tuesSort = item.tuesSort > 0 ? true : false;
							item.wedSort = item.wedSort > 0 ? true : false;
							item.thurSort = item.thurSort > 0 ? true : false;
							item.friSort = item.friSort > 0 ? true : false;
							item.satSort = item.satSort > 0 ? true : false;
							item.sunSort = item.sunSort > 0 ? true : false;
						}
						this.deliveryCycleList = res.data.agents;
					}
				})
				.finally(()=>{
					this.dialogVisible = true;
				});
		},
		// 点击week单选框
		changeWeek(dt, week, flag) {
			let that = this;
			that.$request
				.post("routeMapDeliveryCycleEdit", false, {
					id: dt.id,
					week: week,
					flag: flag ? '1' : '0'
				})
				.then(res => {
					if(res.code == '0') {
						that.$message.success('设置成功');
						that.routeAgentSums = res.data;
					}
				});
		},
		// 关闭
		handleClose() {
			this.dialogVisible = false;
		}
	}
};
</script>
<style lang="scss" scoped>
.route-info-content /deep/ .el-dialog__body {
	padding: 0 5px 20px;
}
.route-info-content /deep/ .el-table .cell,
.route-info-content /deep/ .el-table .el-table__cell,
.route-info-content /deep/ .el-table th.el-table__cell > .cell {
	padding: 1px 5px;
}
.flex-1{
    padding: 10px;
    box-sizing: border-box;
}

.w510{
	width: 510px;
}

.agent-info{
	color: #000;
	font-weight: bold;
	margin-bottom: 3px;
}

.info{
	padding: 5px 10px;
	box-sizing: border-box;
	border-bottom: 2px solid #ddd;
}

.mr30 {
	margin-right: 30px;
}

.title{
    background-color: #e5e5e5;
    color: #333;
    font-size: 14px;
    padding: 10px 5px;
    margin: 10px 10px 0;
	font-weight: bold;
}
</style>
